export class DbBlockingError extends Error {
  constructor() {
    super("Another tab/window is trying to load a newer version of this website and is unable to do so while this tab is open. Close this tab/window and then refresh the other tab/window to update to the newest version.");
    this.name = "DbBlockingError";
  }
}